<template>
  <div class="lane-container filtered">
    <div class="lane">
      <div class="list">

        <header class="task-list-header bg-image clearfix">
          Unassigned
        </header>

        <task-list
          ref="tasklist"
          :list-is-editable="true"
          :goal-id="goalId"
          :list-id="null"
          :tasklist="tasklist_this_lane_filtered"
          :allow-to-reorder="true"
          :show-prop-task-height="showPropTaskHeight"
          :assigned-user-id="assignedUserId"
        />

        <footer style="display: flex; justify-content: space-around;">
          <span class="small" style="float: right">&thinsp;{{itemCount}} items &emsp;&Sigma;&thinsp;{{ durationSum | hoursMinutes }}</span>
        </footer>

      </div>
    </div>
  </div>
</template>

<script>
import TaskList from './TaskList';
import { MAGIC_UID_TEAM } from '@/api/task'

export default {
  props: {
    goalId: {
      type: String,
      default: null
    },
    showFinished: {},
    showArchived: {},
    showPropTaskHeight: {},
    filterByLabel: {},
  },
  data() {
    return {
      assignedUserId: MAGIC_UID_TEAM,
    }
  },
  computed: {
    itemCount() {
      return this.tasklist_this_lane_filtered.length;
    },

    durationSum() {
      return this.tasklist_this_lane_filtered.reduce((v,p) => p.durationRemaining + v, 0)
    },

    tasklist_this_lane_filtered() {
      let tasklist = this.tasklist_this_lane.items
      if ( !this.showFinished ) {
        tasklist = tasklist.filter(item => !item.done)
      }
      if ( !this.showArchived ) {
        tasklist = tasklist.filter(item => !item.deleted)
      }
      if ( this.filterByLabel ) {
        tasklist = tasklist.filter(item => item.label === this.filterByLabel )
      }

      if ( this.search_result ) {
        tasklist = tasklist.filter(item => this.search_result[ item.$id ])
        tasklist.forEach(item => {
          item.matched_text = this.search_result[ item.$id ].matched_text;
        })
      } else {
        tasklist.forEach(item => {
          item.matched_text = null
        })
      }

      return tasklist
    },

    tasklist_this_lane() {
      let all_tasklists = this.$models.task
        .with({ goalId: this.goalId })
        .getters
        .lane_task_list_all_users
      return {
        items: all_tasklists[ null ] || []
      }
    },
  },
  components: {
    TaskList,
  },
};
</script>
